import("./main").then(({ main }) => main());
export {};
